import { render, staticRenderFns } from "./forgetpw.vue?vue&type=template&id=05439859&scoped=true&"
import script from "./forgetpw.vue?vue&type=script&lang=js&"
export * from "./forgetpw.vue?vue&type=script&lang=js&"
import style0 from "./forgetpw.vue?vue&type=style&index=0&id=05439859&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05439859",
  null
  
)

export default component.exports